import { useMutation } from 'react-query';
import { useClient } from 'hooks/useClient';

export interface OtpResponse {
  statusCode: number;
  message: string;
  otp_expires_at: string;
}

export const useRequestOtp = () => {
  const v3 = useClient({ url: process.env.REACT_APP_API_V3, useAuth: false });

  const fn = async (email: string): Promise<OtpResponse> => {
    return v3.requestOtp(email);
  };

  return useMutation(['request-otp'], fn);
};
